export default __webpack_public_path__ + "static/media/imagen_jorge_abajo.bbd434e0.png";